export default () => ({
  companyStatitics: ''
})



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/components/statistics/resources/data.js